import React, { useState } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./control.module.sass";
import Icon from "../../../../../../Icon";
import EyeIcon from '../../../../../../../media/images/icons/eye.png'
import {ReactComponent as ArchiveSvg} from "../../../../../../../media/images/icons/archive.svg"
import Modal from "../../../../../../Modals/ModalComponent";
import ArchiveModal from "../../../../../../Modals/Others/ArchieveModal";

const Control = ({className, access, appid, id, name, status, type}) => {

  const [visibleArchiveModal, setVisibleArchiveModal] = useState(false)

  const actions = [
    {
      pathName : `/view-item/${appid}/${id}`,
      action: () => console.log("edit"),
    },
    {
      icon: "edit",
      pathName : `/edit-item/${appid}/${id}`,
      action: () => console.log("edit"),
    },
    {
      icon: "download",
      action: () => setVisibleArchiveModal(true),
      id : id
    }
  ];

  return (
    <>
      <div className={cn(styles.control, className)}>
        {/* {actions.map((x, index) => (
          <Link to={x.pathName} state={{id : id}} className={styles.button} key={index} onClick={x.action}>
            <Icon name={x.icon} size="20" />
          </Link>
        ))} */}
        {access ? 
          (actions && actions.slice(0, 1).map((x, index) => {
            return(
              <Link to={x.pathName} state={{id : id}} className={styles.button} key={index} onClick={x.action}>
                <img src={EyeIcon} width={20} height={20} className={styles.icon} />
              </Link>
            )
          }))
        : 
          (actions && actions.slice(1).map((x, index) => {
            return(
              <Link to={x.pathName} state={{id : id}} className={styles.button} key={index} onClick={x.action}>
                {x.icon == 'download' ?  <ArchiveSvg /> : <Icon name={x.icon} size="20" className={styles.icon}/>}
              </Link>
            )
          }))
        }
      </div>
      <Modal visible={visibleArchiveModal} onClose={() => setVisibleArchiveModal(false)}>
        <ArchiveModal id={id} name={name} type={type} status={status} onClose={() => setVisibleArchiveModal(false)}/>
      </Modal>
    </>
  );
};

export default Control;
